import { styled } from '../../lib/stitches'
import { gray4 } from '../platform/color'

const Input = styled('input', {
  fontFamily: '$dm',
  userSelect: 'none',
  borderRadius: '5px',
  variants: {
    size: {
      10: { fontSize: '$10', lineHeight: '$16', fontWeight: '$regular' },
      12: { fontSize: '$12', lineHeight: '$18', fontWeight: '$regular' },
      14: { fontSize: '$14', lineHeight: '$20', fontWeight: '$regular' },
      16: { fontSize: '$16', lineHeight: '$24', fontWeight: '$medium' },
      20: { fontSize: '$20', lineHeight: '$24', fontWeight: '$semibold' },
      24: { fontSize: '$24', lineHeight: '$32', fontWeight: '$bold' },
      32: { fontSize: '$32', lineHeight: '$40', fontWeight: '$bold' }
    },
    inputStyle: {
      primary: { color: '$text__primary' },
      secondary: { color: '$text__secondary' },
      tertiary: { color: '$text__tertiary' },
      primary_inverted: { color: '$text_inverted__primary' },
      secondary_inverted: { color: '$text_inverted__secondary' },
      tertiary_inverted: { color: '$text_inverted__tertiary' }
    },
    clear: {
      true: {
        '&:hover': {
          borderColor: gray4
        },
        border: '1px solid transparent',
        background: 'none'
      }
    }
  },
  defaultVariants: {
    size: '12',
    inputStyle: 'primary'
  }
})

export default Input
